import Vue from 'vue'
import Router from 'vue-router'
import IndexPortale from '@/components/IndexPortale'
import IndexPortaleMobile from '@/components/IndexPortaleMobile'

import DashBoard from '@/components/HomePage/DashBoard'
import DashBoardMobile from '@/components/HomePage/DashBoardMobile'
import Links from '@/components/HomePage/LinkUtili'
import Informativa from '@/components/HomePage/Informativa'
import Messaggi from '@/components/MessagesMobile'
import Profilo from '@/components/Profilo/ProfiloMobile'
import Preview from '@/components/HomePage/Preview'

// Documenti Personali
// import IndexDocumenti from '@/components/Documenti/IndexDocumenti'
import IndexDocumenti from '@/components/Documenti/IndexDocumenti'
import IndexDocumentiMobile from '@/components/Documenti/IndexDocumentiMobile'
// import Comunicazioni from '@/components/Documenti/Comunicazioni'
// import Modulistica from '@/components/Documenti/Modulistica'

/*
// App
import Digiposte from '@/components/Digiposte/Digiposte'
import Profilo from '@/components/Profilo/Profilo'

*/

// Presenze
import IndexPresenze from '@/components/PresenzeWeb/IndexPresenze'
import Presenza from '@/components/PresenzeWeb/Presenza'
import Resp from '@/components/PresenzeWeb/Responsabile'
// Presenze - Mobile
import IndexPresenzeMobile from '@/components/PresenzeWebMobile/IndexPresenzeMobile'
import PresenzaMobile from '@/components/PresenzeWebMobile/PresenzaMobile'
import RespMobile from '@/components/PresenzeWebMobile/ResponsabileMobile'

// Ferie
import IndexFerie from '@/components/Ferie/IndexFerie'
import RiepilogoFerie from '@/components/Ferie/RiepilogoFerie'
import Autorizzazioni from '@/components/Ferie/Autorizzazioni'
// Ferie - Mobile
import IndexFerieMobile from '@/components/FerieMobile/IndexFerieMobile'
import RiepilogoFerieMobile from '@/components/FerieMobile/RiepilogoFerieMobile'
import AutorizzazioniMobile from '@/components/FerieMobile/AutorizzazioniMobile'

// Deleghe Sindacali
import IndexDelSind from '@/components/DelegheSindacali/IndexDelSind'
import ElencoPermessi from '@/components/DelegheSindacali/ElencoPermessi'
import ElencoCessioni from '@/components/DelegheSindacali/ElencoCessioni'

// Deleghe Sindacali - Mobile

// Trasferte
import IndexTrasferte from '@/components/Trasferte/IndexTrasferte'
import RiepilogoTrasferte from '@/components/Trasferte/RiepilogoTrasferte'
import DettaglioTrasferta from '@/components/Trasferte/DettaglioTrasferta'
// import NuovaTrasferta from '@/components/Trasferte/NuovaTrasferta'
import RiepilogoAutorizzazioni from '@/components/Trasferte/RiepilogoAutorizzazioni'
import AutorizzaTrasferta from '@/components/Trasferte/AutorizzaTrasferta'
// Trasferte - Mobile
import IndexTrasferteMobile from '@/components/TrasferteMobile/IndexTrasferteMobile'
import RiepilogoTrasferteMobile from '@/components/TrasferteMobile/RiepilogoTrasferteMobile'
import DettaglioTrasfertaMobile from '@/components/TrasferteMobile/DettaglioTrasfertaMobile'
import RiepilogoAutorizzazioniMobile from '@/components/TrasferteMobile/RiepilogoAutorizzazioniMobile'
import AutorizzaTrasfertaMobile from '@/components/TrasferteMobile/AutorizzaTrasfertaMobile'

// Calendar
import IndexCalendar from '@/components/Calendar/IndexCalendar'
import Calendar from '@/components/Calendar/Calendar'

// Sportello Digitale
import IndexSportello from '@/components/SportelloDigitale/IndexSportello'

// Sostituto
import Sostituto from '@/components/Sostituto/Sostituto'

// SharePoint
import IndexSharePoint from '@/components/SharePoint/IndexSharePoint'
import IndexSharePointMobile from '@/components/SharePointMobile/IndexSharePointMobile'

// --Login
import IndexLogin from '@/components/Login/Index'
import IndexLoginMobile from '@/components/Login/IndexMobile'
import Login from '@/components/Login/Login'
import Registrazione from '@/components/Login/Registrazione'
import Recovery from '@/components/Login/Recovery'
import Support from '@/components/Login/Support'

// Ricarica Torrette Auto
import IndexRicAuto from '@/components/TorretteRicAuto/IndexRicAuto'
import PrenotazioneRicAuto from '@/components/TorretteRicAuto/PrenotazioneRicAuto'
import ElencoRicAuto from '@/components/TorretteRicAuto/ElencoRicAuto'

/*
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
*/

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      components: {
        default: IndexPortale,
        mobile: IndexPortaleMobile
      },
      children: [
        {
          path: '',
          name: 'home',
          components: {
            default: DashBoard,
            mobile: DashBoardMobile
          },
          meta: {
            area: 'HOME'
          }
        },
        {
          path: '/links',
          name: 'links',
          components: {
            mobile: Links
          },
          meta: {
            area: 'HOME'
          }
        },
        {
          path: '/informativa',
          name: 'Informativa',
          components: {
            mobile: Informativa
          },
          meta: {
            area: 'HOME'
          }
        },
        {
          path: '/messaggi',
          name: 'messaggi',
          components: {
            mobile: Messaggi
          },
          meta: {
            area: 'HOME'
          }
        },
        {
          path: '/profilo',
          name: 'profilo',
          components: {
            mobile: Profilo
          },
          meta: {
            area: 'HOME'
          }
        },
        {
          path: '/documenti',
          name: 'documenti',
          components: {
            default: IndexDocumenti,
            mobile: IndexDocumentiMobile
          }
        },
        {
          path: '/trasferte',
          name: 'IndexTrasferte',
          components: {
            default: IndexTrasferte,
            mobile: IndexTrasferteMobile
          },
          meta: {
            area: 'trasferte'
          },
          children: [
            {
              path: 'riepilogo',
              name: 'RiepilogoTrasferte',
              components: {
                default: RiepilogoTrasferte,
                mobile: RiepilogoTrasferteMobile
              },
              meta: {
                area: 'trasferte',
                appName: 'trasferteWeb'
              }
            },
            {
              path: 'dettaglio/:id',
              name: 'DettaglioTrasferta',
              components: {
                default: DettaglioTrasferta,
                mobile: DettaglioTrasfertaMobile
              }
            },
            {
              path: 'autorizzazioni',
              name: 'RiepilogoAutorizzazioni',
              components: {
                default: RiepilogoAutorizzazioni,
                mobile: RiepilogoAutorizzazioniMobile
              },
              meta: {
                area: 'trasferte',
                appName: 'trasferteResp'
              }
            },
            {
              path: 'autorizza/:id',
              name: 'AutorizzaTrasferta',
              components: {
                default: AutorizzaTrasferta,
                mobile: AutorizzaTrasfertaMobile
              }
            },
            {
              path: 'sostituto',
              name: 'SostitutoTrasferta',
              component: Sostituto,
              meta: {
                area: 'trasferte',
                appName: 'trasferteSost',
                servizio: 'datisoc'
              }
            }
          ]
        },
        {
          path: '/presenze',
          name: 'IndexPresenze',
          components: {
            default: IndexPresenze,
            mobile: IndexPresenzeMobile
          },
          meta: {
            area: 'presenze'
          },
          children: [
            {
              path: 'presenza',
              name: 'Presenza',
              components: {
                default: Presenza,
                mobile: PresenzaMobile
              },
              meta: {
                area: 'presenze',
                appName: 'presWeb'
              }
            },
            {
              path: 'responsabile',
              name: 'Responsabile',
              components: {
                default: Resp,
                mobile: RespMobile
              },
              meta: {
                area: 'presenze',
                appName: 'presResp'
              }
            }
          ]
        },
        {
          path: '/ferie',
          name: 'IndexFerie',
          components: {
            default: IndexFerie,
            mobile: IndexFerieMobile
          },
          meta: {
            area: 'ferie'
          },
          children: [
            {
              path: 'riepilogo',
              name: 'RiepilogoFerie',
              components: {
                default: RiepilogoFerie,
                mobile: RiepilogoFerieMobile
              },
              meta: {
                area: 'ferie',
                appName: 'demandeConge'
              }
            },
            {
              path: 'autorizzazioni',
              name: 'Autorizzazioni',
              components: {
                default: Autorizzazioni,
                mobile: AutorizzazioniMobile
              },
              meta: {
                area: 'ferie',
                appName: 'respConge'
              }
            },
            {
              path: 'sostituto',
              name: 'Sostituto',
              component: Sostituto,
              meta: {
                area: 'ferie',
                appName: 'suppleantConge',
                servizio: 'ferie'
              }
            }
          ]
        },
        {
          path: '/delsind',
          name: 'IndexDelSind',
          components: {
            default: IndexDelSind,
            mobile: IndexFerieMobile
          },
          meta: {
            area: 'delSind'
          },
          children: [
            {
              path: 'permessi',
              name: 'PermessiSindacali',
              components: {
                default: ElencoPermessi,
                mobile: RiepilogoFerieMobile
              },
              meta: {
                area: 'delSind',
                appName: 'permessi'
              }
            },
            {
              path: 'cessioni',
              name: 'CessioniSindacali',
              components: {
                default: ElencoCessioni,
                mobile: RiepilogoFerieMobile
              },
              meta: {
                area: 'delSind',
                appName: 'permessi'
              }
            }
          ]
        },
        {
          path: '/ricaricaau',
          name: 'IndexRicAuto',
          components: {
            default: IndexRicAuto,
            mobile: IndexRicAuto
          },
          meta: {
            area: 'ricaricaAu'
          },
          children: [
            {
              path: 'PrenotaRicAuto',
              name: 'PrenotaRicAuto',
              components: {
                default: PrenotazioneRicAuto,
                mobile: PrenotazioneRicAuto
              },
              meta: {
                area: 'ricaricaAu',
                appName: 'PrenotaRicAuto'
              }
            },
            {
              path: 'ElencoRicAuto',
              name: 'ElencoRicAuto',
              components: {
                default: ElencoRicAuto,
                mobile: ElencoRicAuto
              },
              meta: {
                area: 'ricaricaAu',
                appName: 'ElencoRicAuto'
              }
            }
          ]
        },
        {
          path: '/calendar',
          name: 'IndexCalendare',
          components: {
            default: IndexCalendar,
            mobile: IndexCalendar
          },
          meta: {
            area: 'calendar'
          },
          children: [
            {
              path: '',
              name: 'Calendar',
              components: {
                default: Calendar,
                mobile: Calendar
              },
              meta: {
                area: 'calendar',
                appName: 'calendar'
              }
            }
          ]
        },
        {
          path: '/sportello',
          name: 'IndexSportello',
          component: IndexSportello,
          meta: {
            area: 'sportello'
          }
        },
        {
          path: '/sharepoint',
          name: 'IndexSharePoint',
          components: {
            default: IndexSharePoint,
            mobile: IndexSharePointMobile
          },
          meta: {
            area: 'sharepoint'
          },
          children: [
            {
              path: 'documenti',
              name: 'DocumentiSP',
              components: {
                default: () => import('@/components/SharePoint/Documenti.vue'),
                mobile: () => import('@/components/SharePointMobile/DocumentiMobile.vue')
              },
              meta: {
                area: 'ferie',
                appName: 'demandeConge'
              }
            }
          ]
        }
      ]
    },
    {
      path: '/login',
      components: {
        default: IndexLogin,
        mobile: IndexLoginMobile
      },
      children: [
        {
          path: '',
          name: 'Login',
          component: Login
        },
        {
          path: 'registrazione',
          name: 'Registrazione',
          component: Registrazione
        },
        {
          path: 'recovery',
          name: 'Recovery',
          component: Recovery
        },
        {
          path: 'support',
          name: 'Support',
          component: Support
        }
      ]
    },
    {
      path: '/preview/:id',
      name: 'preview',
      components: {
        default: Preview,
        mobile: Preview
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js